<template>
  <div id="videoRecord">
    <el-row class="data_head">
      <el-col>

      </el-col>
      <el-col>
        <div class="text_panel">测点</div>
        <el-select v-model="channelId" placeholder="请选择">
          <el-option
            v-for="item in cameras"
            :key="item.channelId"
            :label="item.name"
            :value="item.channelId">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="dates"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" @click.native="search()" class="searchButton">查&nbsp;询</el-button>
      </el-col>
    </el-row>
    <div class="table tableContent">
      <el-table :data="data" style="width: 100%" :header-cell-style="{background:'#335ABB',color:'#FFF'}" stripe
                v-loading="canDownload" :element-loading-text="downloadText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-table-column align="center" prop="name" label="设备名称"></el-table-column>
        <el-table-column align="center" prop="startTime" label="开始时间"></el-table-column>
        <el-table-column align="center" prop="endTime" label="结束时间"></el-table-column>
        <el-table-column align="center" label="文件大小">
          <template slot-scope="scope">
            {{ formatFileSize(scope.row.fileSize) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="play(scope.row)" class="deleteButton">播&nbsp;放
            </el-button>
            <el-button size="mini" type="primary" @click="download(scope.row)" class="checkButton">下&nbsp;载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="回放"
      :visible.sync="live"
      :modal-append-to-body='false'
      :close-on-click-modal="false"
      :before-close="stopPlay"
      center
      width="60%"
    >
      <div style="position: relative; width: 100%; height: 400px;">
        <div id="jessibucaContainer" style="width: 100%; height: 100%; background: #000;"></div>
        <div
          v-if="videoLoading"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.7); z-index: 10;">
          <div style="text-align: center; color: #fff;">
            <i class="el-icon-loading" style="font-size: 40px; animation: rotating 2s linear infinite;"></i>
            <div style="margin-top: 10px; font-size: 14px;">视频加载中...</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">

    <el-button type="primary" @click="stopPlay">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "videoRecord",
  data() {
    return {
      dates: [],
      live: false,
      data: [],
      durationTime: 0,
      downloadText: '下 载 中',
      canDownload: false,
      cameras: [],
      channelId: '',
      deviceId: '',
      streamid: null,
      downloadUrl: null,
      loading: null,
      videoLoading: false, // 视频加载状态
      playbackTimeout: null, // 播放超时定时器
      // jessibuca 实例不放在 data 中（避免 Vue 响应式追踪导致性能问题）
      // 通过 this._jessibuca 访问
    };

  },
  mounted: function () {
    this.getDateNow();
    this.measureVideoList();
  },
  methods: {
    // 获取视频测点列表，参考 real-time-data-normal.vue 的逻辑
    measureVideoList() {
      this.$axios
        .get(`/api/monitor/measure/videoMeasures?childProjectId=${localStorage.getItem("mainId")}`)
        .then(res => {
          if (res.data.status == 200) {
            const values = res.data.datas.values || [];
            if (values.length === 0) {
              this.$message({
                type: "info",
                message: "暂无视频监控数据",
                showClose: true
              });
              return;
            }

            // 构造摄像头列表，使用返回数据中的 channelId 字段，measureName 作为 name
            this.cameras = values.map(item => {
              const channelId = item.channelId || item.measureNo || item.code;
              const deviceId = item.deviceId || item.measureNo || item.code;
              const measureName = item.measureName || item.name || channelId;
              return {
                name: measureName,
                channelId: channelId,
                deviceId: deviceId
              };
            });

            // 设置默认选中的第一个摄像头
            if (this.cameras.length > 0) {
              this.channelId = this.cameras[0].channelId;
              this.deviceId=this.cameras[0].deviceId;
              // 如果有日期范围，则执行查询
              if (this.dates && this.dates.length === 2) {
                this.search();
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message || "获取视频测点列表失败",
              showClose: true
            });
          }
        })
        .catch(e => {
          console.log('获取视频测点列表失败:', e);
          this.$message({
            type: "error",
            message: "获取视频测点列表失败",
            showClose: true
          });
        });
    },
    downloadDelay() {
      if (this.durationTime <= 0) {
        this.downloadText = "下 载 中";
        this.canDownload = false;
        this.stopPlay();
        window.open(this.downloadUrl)
        return;
      }
      setTimeout(() => {
        this.durationTime--;
        this.downloadText = "下载中，预计还需要" + this.durationTime + "秒"
        this.downloadDelay();
      }, 1000)
    },
    play(row) {
      // 立即显示loading（在接口调用前）
      this.videoLoading = true;

      // 1. 先清理上一次的播放器，防止残留旧流地址
      this.cleanupPlayer();

      // 2. 如果有旧 streamid，先停止后端流（不等响应）
      if (this.streamid) {
        const oldStreamid = this.streamid;
        this.streamid = null;
        this.$axios.get(`/api/monitor/video/playbackStop?stream=${oldStreamid}&channelId=${this.channelId}&deviceId=${this.deviceId}`).catch(() => {});
      }

      // 3. 请求新的回放流
      this.$axios.get(`/api/monitor/video/playbackStart?startTime=${row.startTime}&endTime=${row.endTime}&channelId=${this.channelId}&deviceId=${this.deviceId}`).then(res => {
        // 检查响应状态
        if (res.data.status != 200) {
          this.videoLoading = false;
          this.$message({
            type: "error",
            message: res.data.message || "获取视频流失败",
            showClose: true
          });
          return;
        }

        // 检查数据是否存在
        if (!res.data.datas || !res.data.datas.values) {
          this.videoLoading = false;
          this.$message({
            type: "error",
            message: "视频流数据格式错误",
            showClose: true
          });
          return;
        }

        const values = res.data.datas.values;
        this.streamid = values.stream;

        // 打印返回数据，便于诊断流地址
        console.log('[playbackStart] 返回数据:', values);

        // 4. 选择播放地址：Jessibuca 优先 ws-flv / wss-flv（WASM 软解 H.265）
        const isHttps = window.location.protocol === 'https:';
        let playUrl = null;

        if (isHttps) {
          // https 环境优先 wss_flv，回退到 https_flv 转 wss
          if (values.wss_flv) { playUrl = values.wss_flv; }
          else if (values.ws_flv) { playUrl = values.ws_flv; }
          else if (values.https_flv) { playUrl = values.https_flv.replace(/^https:/, 'wss:'); }
          else if (values.flv) { playUrl = values.flv.replace(/^http:/, 'ws:'); }
          else if (values.flv) { playUrl = values.flv; }
        } else {
          // http 环境优先 ws_flv，回退到 flv 转 ws
          if (values.ws_flv) { playUrl = values.ws_flv; }
          else if (values.flv) { playUrl = values.flv.replace(/^http:/, 'ws:'); }
          else if (values.wss_flv) { playUrl = values.wss_flv; }
          else if (values.https_flv) { playUrl = values.https_flv.replace(/^https:/, 'wss:'); }
          else if (values.flv) { playUrl = values.flv; }
        }

        if (!playUrl) {
          this.videoLoading = false;
          this.$message({
            type: "error",
            message: "未获取到视频流地址",
            showClose: true
          });
          return;
        }

        console.log('[playbackStart] Jessibuca 播放地址:', playUrl);

        // 5. 显示弹窗
        this.live = true;

        this.$nextTick(() => {
          // 等待 500ms 确保 ZLMediaKit 流就绪后再请求
          setTimeout(() => {
            this.startPlayback(playUrl);
          }, 500);
        });
      }).catch(e => {
        // 接口调用失败，关闭loading并显示错误
        this.videoLoading = false;
        console.log('播放视频失败:', e);
        let errorMessage = "播放视频失败";
        if (e.response && e.response.data && e.response.data.message) {
          errorMessage = e.response.data.message;
        } else if (e.response && e.response.status) {
          errorMessage = `请求失败，状态码：${e.response.status}`;
        } else if (e.message) {
          errorMessage = e.message;
        }
        this.$message({
          type: "error",
          message: errorMessage,
          showClose: true
        });
      });
    },
    // 清理 Jessibuca 播放器实例（不调用后端接口）
    cleanupPlayer() {
      if (this._jessibuca) {
        try {
          this._jessibuca.destroy();
        } catch (e) {
          console.log('销毁 Jessibuca 播放器失败:', e);
        }
        this._jessibuca = null;
      }
    },
    // 用 Jessibuca 播放（WASM 软解，支持 H.265）
    startPlayback(url) {
      const container = document.getElementById('jessibucaContainer');
      if (!container) {
        this.videoLoading = false;
        this.$message({
          type: "error",
          message: "播放器容器未找到",
          showClose: true
        });
        return;
      }

      // 确保旧播放器已清除
      this.cleanupPlayer();

      // 检查 Jessibuca 是否已加载
      if (typeof window.Jessibuca === 'undefined') {
        this.videoLoading = false;
        this.$message({
          type: "error",
          message: "Jessibuca 播放器未加载，请检查网络或刷新页面",
          showClose: true
        });
        return;
      }

      // 超时处理
      this.playbackTimeout = setTimeout(() => {
        if (this.videoLoading) {
          this.videoLoading = false;
          this.$message({
            type: "warning",
            message: "视频加载超时，请检查网络连接",
            showClose: true
          });
        }
      }, 15000);

      try {
        // 创建 Jessibuca 实例，WASM 软解码 H.265
        this._jessibuca = new window.Jessibuca({
          container: container,
          decoder: '/static/jessibuca/decoder.js',
          videoBuffer: 0.2,       // 缓冲时长(秒)
          isResize: true,         // 自适应容器大小
          loadingText: '视频加载中...',
          debug: false,
        });

        // 监听播放开始
        this._jessibuca.on('play', () => {
          this.videoLoading = false;
          clearTimeout(this.playbackTimeout);
        });

        // 监听错误
        this._jessibuca.on('error', (err) => {
          this.videoLoading = false;
          clearTimeout(this.playbackTimeout);
          console.log('Jessibuca 播放错误:', err);
          this.$message({
            type: "error",
            message: "视频播放失败",
            showClose: true
          });
        });

        // 开始播放
        this._jessibuca.play(url);
      } catch (e) {
        this.videoLoading = false;
        clearTimeout(this.playbackTimeout);
        console.log('创建 Jessibuca 播放器失败:', e);
        this.$message({
          type: "error",
          message: "创建视频播放器失败",
          showClose: true
        });
      }
    },
    download(row) {
      // 显示表格loading
      this.canDownload = true;
      this.downloadText = '正在获取视频流...';

      this.$axios.get(`/api/monitor/video/download?startTime=${row.startTime}&endTime=${row.endTime}&channelId=${this.channelId}&deviceId=${this.deviceId}&downloadSpeed=4`).then(res => {
        // 检查响应状态
        if (res.data.status != 200) {
          this.canDownload = false;
          this.$message({
            type: "error",
            message: res.data.message || "获取视频流失败",
            showClose: true
          });
          return;
        }

        // 检查数据是否存在
        if (!res.data.datas || !res.data.datas.values) {
          this.canDownload = false;
          this.$message({
            type: "error",
            message: "视频流数据格式错误",
            showClose: true
          });
          return;
        }

        const values = res.data.datas.values;
        this.streamid = values.stream;

        // 判断当前页面协议，选择匹配协议的下载地址
        const isHttps = window.location.protocol === 'https:';
        let downloadUrl = null;
        let fileExtension = 'mp4';

        if (isHttps) {
          // https环境下优先 https_fmp4 -> fmp4 -> https_flv -> flv -> https_ts -> ts
          if (values.https_fmp4) { downloadUrl = values.https_fmp4; fileExtension = 'mp4'; }
          else if (values.fmp4) { downloadUrl = values.fmp4; fileExtension = 'mp4'; }
          else if (values.https_flv) { downloadUrl = values.https_flv; fileExtension = 'flv'; }
          else if (values.flv) { downloadUrl = values.flv; fileExtension = 'flv'; }
          else if (values.https_ts) { downloadUrl = values.https_ts; fileExtension = 'ts'; }
          else if (values.ts) { downloadUrl = values.ts; fileExtension = 'ts'; }
        } else {
          // http环境下优先 fmp4 -> flv -> ts
          if (values.fmp4) { downloadUrl = values.fmp4; fileExtension = 'mp4'; }
          else if (values.flv) { downloadUrl = values.flv; fileExtension = 'flv'; }
          else if (values.ts) { downloadUrl = values.ts; fileExtension = 'ts'; }
        }

        // 检查是否找到可用的下载链接
        if (!downloadUrl) {
          this.canDownload = false;
          this.$message({
            type: "error",
            message: "未获取到可用的视频流地址",
            showClose: true
          });
          return;
        }

        // 开始轮询下载进度
        this.downloadText = '正在下载录像，请稍候...';
        this.pollDownloadProgress(downloadUrl, row, fileExtension);
      }).catch(e => {
        this.canDownload = false;
        console.log('下载视频失败:', e);
        let errorMessage = "下载视频失败";
        if (e.response && e.response.data && e.response.data.message) {
          errorMessage = e.response.data.message;
        } else if (e.response && e.response.status) {
          errorMessage = `请求失败，状态码：${e.response.status}`;
        } else if (e.message) {
          errorMessage = e.message;
        }
        this.$message({
          type: "error",
          message: errorMessage,
          showClose: true
        });
      });
    },
    // 轮询下载进度
    pollDownloadProgress(downloadUrl, row, fileExtension) {
      if (!this.streamid) {
        return;
      }
      this.$axios.get(`/api/monitor/video/downloadProgress?stream=${this.streamid}&channelId=${this.channelId}&deviceId=${this.deviceId}`).then(res => {
        let progress = 0;
        if (res.data.status == 200 && res.data.datas && res.data.datas.values) {
          progress = res.data.datas.values.progress || 0;
        }
        const percent = Math.round(progress * 100);
        this.downloadText = `正在下载录像... ${percent}%`;

        if (progress >= 1 || percent >= 100) {
          // 下载完成，开始保存文件
          this.downloadText = '正在保存文件...';
          this.downloadVideoFile(downloadUrl, row, fileExtension);
        } else {
          // 继续轮询
          setTimeout(() => this.pollDownloadProgress(downloadUrl, row, fileExtension), 2000);
        }
      }).catch(() => {
        // 进度查询失败，直接尝试下载
        this.downloadText = '正在保存文件...';
        this.downloadVideoFile(downloadUrl, row, fileExtension);
      });
    },
    // 下载视频文件
    downloadVideoFile(downloadUrl, row, fileExtension) {
      // 生成文件名：设备名称_开始时间_结束时间.扩展名
      const safeStartTime = (row.startTime || '').replace(/[: ]/g, '_');
      const safeEndTime = (row.endTime || '').replace(/[: ]/g, '_');
      const fileName = `${row.name || 'video'}_${safeStartTime}_${safeEndTime}.${fileExtension}`;

      // 尝试使用fetch下载
      fetch(downloadUrl, { method: 'GET' })
        .then(response => {
          if (!response.ok) {
            throw new Error('下载失败');
          }
          return response.blob();
        })
        .then(blob => {
          // 创建blob URL并触发下载
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$message({
            type: "success",
            message: "视频下载成功",
            showClose: true
          });
          this.stopDownload();
        })
        .catch(() => {
          // fetch失败（可能跨域），尝试直接下载
          try {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$message({
              type: "success",
              message: "开始下载视频",
              showClose: true
            });
          } catch (err) {
            // 最后尝试在新窗口打开
            window.open(downloadUrl, '_blank');
            this.$message({
              type: "info",
              message: "已在新窗口打开视频流，请右键保存",
              showClose: true
            });
          }
          this.stopDownload();
        });
    },
    // 停止下载流并清理
    stopDownload() {
      this.canDownload = false;
      if (this.streamid) {
        const sid = this.streamid;
        this.streamid = null;
        this.$axios.get(`/api/monitor/video/downloadStop?stream=${sid}&channelId=${this.channelId}&deviceId=${this.deviceId}`).catch(e => {
          console.log('停止下载流失败:', e);
        });
      }
    },
    stopPlay(isdownload) {
      // 关闭loading
      this.videoLoading = false;

      // 清除超时定时器
      if (this.playbackTimeout) {
        clearTimeout(this.playbackTimeout);
        this.playbackTimeout = null;
      }

      // 清理 Jessibuca 播放器实例
      this.cleanupPlayer();

      if (this.live) {
        this.live = false;
      }
      if (this.streamid == null) {
        return;
      }
      this.$axios.get(`/api/monitor/video/playbackStop?stream=${this.streamid}&channelId=${this.channelId}&deviceId=${this.deviceId}`).then(res => {
        if (isdownload) {
          console.log(res)
        }
        this.streamid = null;
      }).catch(e => {
        console.log('停止播放失败:', e);
        this.streamid = null;
      });
    },
    search() {
      if (!this.channelId) {
        this.$message({
          type: "warning",
          message: "请选择摄像头",
          showClose: true
        });
        return;
      }
      if (!this.dates || this.dates.length !== 2 || !this.dates[0] || !this.dates[1]) {
        this.$message({
          type: "warning",
          message: "请选择日期范围",
          showClose: true
        });
        return;
      }
      this.$axios.get(`/api/monitor/video/getRecords?startTime=${this.dates[0]}&endTime=${this.dates[1]}&channelId=${this.channelId}&deviceId=${this.deviceId}`).then((res) => {
        if (res.data.status == 200) {
          this.data = res.data.datas.values || [];
        } else {
          this.$message({
            type: "error",
            message: res.data.message || "查询失败",
            showClose: true
          });
          this.data = [];
        }
      }).catch(e => {
        console.log('查询录像列表失败:', e);
        this.$message({
          type: "error",
          message: "查询录像列表失败",
          showClose: true
        });
        this.data = [];
      });
    },

    getDateNow() {
      let date = new Date();
      let month = ''
      let lastDay = ''
      let nextDay = ''
      if ((date.getMonth() + 1) < 10) {
        month = '0' + (date.getMonth() + 1)
      } else {
        month = (date.getMonth() + 1)
      }
      if ((date.getDate() - 1) < 10) {
        lastDay = '0' + (date.getDate() - 1)
      } else {
        lastDay = (date.getDate() - 1)
      }
      if (date.getDate() < 10) {
        nextDay = '0' + date.getDate()
      } else {
        nextDay = date.getDate()
      }
      if (this.$route.query.measureNo) {
        this.dates = [this.$route.query.startDate, this.$route.query.endDate]
      } else {
        this.dates.push(
          date.getFullYear() +
          "-" +
          month +
          "-" +
          lastDay + " 00:00:00"
        );
        this.dates.push(
          date.getFullYear() +
          "-" +
          month +
          "-" +
          nextDay + " 00:00:00"
        );
      }
    },
    // 格式化文件大小，将字节转换为对人友好的单位
    formatFileSize(fileSize) {
      if (!fileSize) {
        return '-';
      }

      // 将字符串转换为数字
      const size = parseInt(fileSize, 10);

      if (isNaN(size) || size < 0) {
        return '-';
      }

      // 定义单位
      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      let unitIndex = 0;
      let fileSizeValue = size;

      // 转换为合适的单位
      while (fileSizeValue >= 1024 && unitIndex < units.length - 1) {
        fileSizeValue /= 1024;
        unitIndex++;
      }

      // 保留2位小数，如果小数部分为0则不显示
      const formattedSize = fileSizeValue % 1 === 0
        ? fileSizeValue.toString()
        : fileSizeValue.toFixed(2);

      return `${formattedSize} ${units[unitIndex]}`;
    }
  },
  destroyed() {
    this.stopPlay();
    this.stopDownload();
    // 确保 Jessibuca 播放器被销毁
    this.cleanupPlayer();
  }
};
</script>

<style>
#videoRecord .el-table {
  color: #A7CCF6;
}

#videoRecord .el-loading-spinner {
  top: 10%
}

#videoRecord .el-table .info-warn {
  color: red;
}

#videoRecord .el-table__row {
  background-color: #0B3A68 !important;
}

#videoRecord .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #021535;
}

#videoRecord .el-table td {
  border: unset;
}

#videoRecord .el-table th.is-leaf {
  border-bottom: none;
}

#videoRecord .el-select .el-input__inner {
  background-color: #3457DE;
  color: #FFF;
}

#videoRecord .el-date-editor .el-range-input {
  background-color: #3457DE;
  color: #FFF;
}

#videoRecord .el-date-editor--datetimerange.el-input__inner {
  background-color: #3457DE;
}


#videoRecord .el-date-editor .el-range-separator {
  background-color: unset;
  color: #FFF;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style scoped>
@import url('../../assets/css/style.css');

.deleteButton {
  background: #FB4D4B;
  border-color: #FB4D4B;
  color: #FFF;
}

.checkButton {
  background: #E68F02;
  border-color: #E68F02;
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/dataManage/videoRecords.vue